// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2DpYl","content":"GlobalSearch_content__1E2wy"};